document.addEventListener("DOMContentLoaded", () => {
  const product = document.querySelector(".main-product");

  if (!product) return;

  const purchaseForm = product.querySelector('form[action*="/cart/add"]');
  const priceLabel = product.querySelector('[data-add-to-cart-price]');
  const purchasePrice = product.querySelector('.main-product__purchase-price');
  const sealData = product.querySelector('[data-seal-price-data]');
  const prices = sealData ? JSON.parse(sealData.textContent) : null;
  const sealBlock = product.querySelector('[data-seal-subscription]');
  function updatePurchasePrice() {
    if (!prices || !purchaseForm) return;
    const planId = String(new FormData(purchaseForm).get('selling_plan') || '');
    const price = planId ? prices.plans[planId] : prices.base;
    if (price == null) return;
    if (priceLabel) priceLabel.textContent = price;
    if (purchasePrice) purchasePrice.textContent = price;
  }
  document.addEventListener('sealsubs:selling_plan_changed', (event) => {
    if (!sealBlock || !(event.detail?.element instanceof Element) || !sealBlock.contains(event.detail.element)) return;
    const planId = String(event.detail.selling_plan_id || '');
    if (planId && !Object.hasOwn(prices.plans, planId)) return;
    let inputs = purchaseForm.querySelectorAll('input[name="selling_plan"]');
    if (!inputs.length) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      purchaseForm.append(input);
      inputs = [input];
    }
    inputs.forEach((input) => { input.value = planId; });
    updatePurchasePrice();
  });
  purchaseForm?.addEventListener('change', () => queueMicrotask(updatePurchasePrice));
  document.addEventListener('sealsubs:subscription_widget_created', () => {
    updatePurchasePrice();
  });
  if (sealBlock) {
    const observer = new MutationObserver(() => { updatePurchasePrice(); });
    observer.observe(sealBlock.querySelector('.sealsubs-target-element'), {
      childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'style', 'class', 'hidden'],
    });
  }
  updatePurchasePrice();

  let isAdding = false;
  purchaseForm?.addEventListener('submit', async (event) => {
    if (!window.themeCartDrawer) return;
    event.preventDefault();
    if (isAdding) return;
    const button = purchaseForm.querySelector('.main-product__add');
    if (!button || button.disabled) return;
    const label = button.querySelector('[data-add-to-cart-label]');
    const status = product.querySelector('[data-product-cart-status]');
    updatePurchasePrice();
    const payload = new FormData(purchaseForm);
    if (!payload.get('selling_plan')) payload.delete('selling_plan');
    isAdding = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    if (status) status.textContent = '';
    let added = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: payload,
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this product. Please try again.');
      added = true;
      await window.themeCartDrawer.refreshAndOpen();
    } catch (error) {
      if (status) status.textContent = added
        ? 'Added to your cart. The preview could not load; open your cart from the header.'
        : error.message || 'Could not add this product. Please try again.';
    } finally {
      isAdding = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label) label.textContent = 'Add to cart';
    }
  });

  /* ========================================================
     SELECTOR DE CANTIDAD
  ======================================================== */

  product
    .querySelectorAll(".main-product__quantity-control")
    .forEach((control) => {
      const input = control.querySelector(".main-product__quantity-input");

      if (!input) return;

      control.addEventListener("click", (event) => {
        const button = event.target.closest(
          "[data-quantity-minus], [data-quantity-plus]",
        );

        if (!button || !control.contains(button)) return;

        if (!Number.isFinite(input.valueAsNumber)) {
          input.value = input.min || "1";
        }

        if (button.hasAttribute("data-quantity-minus")) {
          input.stepDown();
        } else {
          input.stepUp();
        }

        input.dispatchEvent(new Event("input", { bubbles: true }));

        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

  /* ========================================================
     GSAP
  ======================================================== */

  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);
  const mediaQueries = gsap.matchMedia();
  mediaQueries.add('(min-width: 801px)', () => {

  /* ========================================================
     ELEMENTOS
  ======================================================== */

  const purchase = product.querySelector(".main-product__purchase");

  const intro = product.querySelector(".main-product__intro");

  const features = Array.from(
    product.querySelectorAll(".main-product__feature"),
  );

  const images = Array.from(
    product.querySelectorAll(".main-product__feature-image"),
  );

  const backTop = product.querySelector(".main-product__back-top");

  const mainImage = images.find((image) => image.dataset.mediaIndex === "main");

  if (!mainImage) return;

  /* ========================================================
     ESTADO
  ======================================================== */

  let currentImage = "main";
  let imageTimeline = null;

  /* ========================================================
     CAMBIO DE IMAGEN
  ======================================================== */

  function showImage(index) {
    const newImage =
      images.find((image) => image.dataset.mediaIndex === String(index)) ||
      mainImage;

    const newIndex = newImage.dataset.mediaIndex;

    if (currentImage === newIndex) return;

    const currentElement = images.find(
      (image) => image.dataset.mediaIndex === currentImage,
    );

    if (imageTimeline) {
      imageTimeline.kill();
    }

    images.forEach((image) => {
      if (image !== currentElement) {
        gsap.set(image, {
          autoAlpha: 0,
          scale: 0.94,
        });
      }
    });

    imageTimeline = gsap.timeline();
    if ((document.documentElement.dataset.animations === "false" || matchMedia("(prefers-reduced-motion: reduce)").matches)) imageTimeline.timeScale(1000);

    /* 1. Ocultar imagen actual */

    if (currentElement) {
      imageTimeline.to(currentElement, {
        autoAlpha: 0,
        scale: 0.94,
        duration: 0.35,
        ease: "power2.in",
      });
    }

    /* 2. Preparar imagen nueva */

    imageTimeline.set(newImage, {
      autoAlpha: 0,
      scale: 0.94,
    });

    /* 3. Pausa */

    imageTimeline.to(
      {},
      {
        duration: 0.12,
      },
    );

    /* 4. Mostrar imagen nueva */

    imageTimeline.to(newImage, {
      autoAlpha: 1,
      scale: 1,
      duration: 0.5,
      ease: "power2.out",
    });

    currentImage = newIndex;
  }

  /* ========================================================
     ESTADO INICIAL
  ======================================================== */

  images.forEach((image) => {
    const isMain = image.dataset.mediaIndex === "main";

    gsap.set(image, {
      autoAlpha: isMain ? 1 : 0,
      scale: isMain ? 1 : 0.94,
    });
  });

  /* ========================================================
     COMPRA (PRIMERA SECCIÓN)
  ======================================================== */

  if (purchase) {
    ScrollTrigger.create({
      trigger: purchase,
      start: "top center",
      end: "bottom center",

      onEnter: () => showImage("main"),
      onEnterBack: () => showImage("main"),
    });
  }

  /* ========================================================
     INTRO
  ======================================================== */

  if (intro) {
    ScrollTrigger.create({
      trigger: intro,
      start: "top center",
      end: "bottom center",

      onEnter: () => showImage("main"),
      onEnterBack: () => showImage("main"),
    });
  }

  /* ========================================================
     CARACTERÍSTICAS
  ======================================================== */

  features.forEach((feature) => {
    const index = feature.dataset.featureIndex;

    ScrollTrigger.create({
      trigger: feature,
      start: "top center",
      end: "bottom center",

      onEnter: () => showImage(index),
      onEnterBack: () => showImage(index),
    });
  });

  /* ========================================================
     BACK TO TOP (ÚLTIMA SECCIÓN)
  ======================================================== */

  if (backTop) {
    ScrollTrigger.create({
      trigger: backTop,
      start: "top center",

      onEnter: () => {
        showImage("main");
      },

      onLeaveBack: () => {
        const lastFeature = features[features.length - 1];

        if (lastFeature) {
          showImage(lastFeature.dataset.featureIndex);
        } else {
          showImage("main");
        }
      },
    });
  }

  /* ========================================================
     ACTUALIZAR TRIGGERS
     Esperamos que carguen las imágenes.
  ======================================================== */

  const refresh = () => ScrollTrigger.refresh();
  window.addEventListener('load', refresh, { once: true });

  ScrollTrigger.refresh();
  return () => { imageTimeline?.kill(); window.removeEventListener('load', refresh); };
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(product)) mediaQueries.revert();
  });
});
